<div class="form-group">
  <label class="control-label">{{label}}</label>
  <ng-select class="custom" [items]="options" bindValue="value" bindLabel="label" [(ngModel)]="model"
    (change)="change()"></ng-select>
</div>